module.exports = __webpack_public_path__ + "media/images/admin/icons/chuspic-39c5ff7001bb37f7acb8de930a122db5.png";